import Box from '@mui/material/Box'
import { Rocket20Regular } from '@/components/Icon'
import PlanUsagePlanTierCard from './PlanUsagePlanTierCard'

export function PlanUsageUpgradePlanCard() {
  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <PlanUsagePlanTierCard
        sectionAriaLabel="Available plan upgrade"
        shellTitle="Upgrade available"
        titleIcon={<Rocket20Regular />}
        planName="Enterprise+"
        priceLine="$XXX/mo"
        description="Get maximum value with 20x usage limits and early access to advanced features."
        actionLabel="Upgrade"
        onAction={() => {}}
      />
    </Box>
  )
}
